import { useState, useEffect, useCallback } from 'react';
import API from '../common/api.js';

const useLeadHistoricalEvents = ({ leadId }) => {
    const [historicalEvents, setHistoricalEvents] = useState([]);
    const [loading, setLoading] = useState(true);
    const [errorMessage, setErrorMessage] = useState(null);
    const [initialized, setInitialized] = useState(false);

    const loadData = useCallback(async () => {
        setLoading(true);
        setErrorMessage(null);

        let historicalEventsIfSuccess = await API.getLeadHistoricalEvents(leadId);

        if (historicalEventsIfSuccess) {
            setHistoricalEvents(historicalEventsIfSuccess);
            setInitialized(true);
        } else {
            setErrorMessage('Failed to load leads from server. Please retry.');
        }

        setLoading(false);
    }, [leadId]);

    useEffect(() => {
        loadData();
    }, [loadData]);

    return {
        historicalEvents,
        loading,
        errorMessage,
        initialized,
        reload: loadData,
    };
};

export default useLeadHistoricalEvents;
